/**
 * ConversationHistoryModal - Modal de histórico de movimentações da conversa
 * 
 * Exibe timeline premium com todas as ações/movimentações de uma conversa:
 * - Criação da conversa
 * - Mudanças de status (open, closed, spam, pending)
 * - Transferências (agente, departamento)
 * - Pausa/reativação de bot
 * - Atribuição de agente
 * 
 * Design moderno com ícones grandes e cards elevados
 * 
 * RELEASE: v2.0.0 - 2026-01-08 - Redesign para layout premium
 */

import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle 
} from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import { History } from 'lucide-react';
import { ConversationHistoryTimelinePremium } from './ConversationHistoryTimelinePremium';

// Props do componente
interface ConversationHistoryModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  conversationId: string | null;
}

/**
 * Modal de histórico de movimentações com design premium
 */
export function ConversationHistoryModal({
  open,
  onOpenChange,
  conversationId,
}: ConversationHistoryModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl h-[75vh] flex flex-col overflow-hidden p-0">
        {/* Header do modal */}
        <DialogHeader className="px-6 pt-6 pb-4 border-b">
          <DialogTitle className="flex items-center gap-2.5 text-base font-semibold">
            <div className="h-8 w-8 rounded-lg bg-primary/10 flex items-center justify-center">
              <History className="h-4 w-4 text-primary" />
            </div>
            Histórico de Movimentações
          </DialogTitle>
        </DialogHeader>

        {/* Área de scroll com timeline premium */}
        <ScrollArea className="flex-1 min-h-0">
          <div className="p-6">
            <ConversationHistoryTimelinePremium 
              conversationId={conversationId}
              isActive={open}
            />
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
